<ng-container *ngIf="!!data && config$ | async as config; else noData">
  <section *ngIf="data.connectionObject as connectionObject">
    <h3>Anschlussobjekt</h3>
    <app-value-with-label
      [label]="'Postleitzahl / Ort'"
      [value]="connectionObject.zipCode + ' ' + connectionObject.city" />
    <app-value-with-label [breakLineBefore]="true" [label]="'Straße'" [value]="connectionObject.street" />
    <app-value-with-label
      [breakLineBefore]="true"
      [label]="'Hausnummer'"
      [value]="connectionObject.streetNo" />
  </section>
  <section>
    <h3>Kontaktdaten</h3>
    <section *ngIf="data.customer as customer">
      <h4>Anschrift des Anschlussnehmers</h4>
      <app-value-with-label
        [label]="'Name'"
        [value]="
          (customer.firstName || customer.company) + ' ' + (customer.lastName || customer.companyAddition)
        " />
      <app-value-with-label
        [breakLineBefore]="true"
        [label]="'Postleitzahl / Ort'"
        [value]="customer.zipCode + ' ' + customer.city" />
      <app-value-with-label [breakLineBefore]="true" [label]="'Strasse'" [value]="customer.street" />
      <app-value-with-label [breakLineBefore]="true" [label]="'Hausnummer'" [value]="customer.streetNo" />
      <app-value-with-label [breakLineBefore]="true" [label]="'E-Mail'" [value]="customer.mail" />
      <app-value-with-label [breakLineBefore]="true" [label]="'Telefonnummer'" [value]="customer.phone" />
    </section>
    <section
      *ngIf="
        config.differingInvoiceContactField !== FieldConfigEnum.HIDDEN &&
        data.invoiceContact as invoiceContact
      ">
      <h4>Rechnungsempfänger</h4>
      <ng-container *ngIf="!!invoiceContact?.salutation; else identicalAddress">
        <app-value-with-label
          [label]="'Name'"
          [value]="invoiceContact.firstName + ' ' + invoiceContact.lastName" />
        <app-value-with-label
          [breakLineBefore]="true"
          [label]="'Postleitzahl / Ort'"
          [value]="invoiceContact.zipCode + ' ' + invoiceContact.city" />
        <app-value-with-label [breakLineBefore]="true" [label]="'Strasse'" [value]="invoiceContact.street" />
        <app-value-with-label
          [breakLineBefore]="true"
          [label]="'Hausnummer'"
          [value]="invoiceContact.streetNo" />
        <app-value-with-label [breakLineBefore]="true" [label]="'E-Mail'" [value]="invoiceContact.mail" />
        <app-value-with-label
          [breakLineBefore]="true"
          [label]="'Telefonnummer'"
          [value]="invoiceContact.phone" />
      </ng-container>
      <ng-template #identicalAddress>
        <p>Rechnungsadresse ist identisch mit Anschrift des Anschlussnehmers</p>
      </ng-template>
    </section>
  </section>
  <section *ngIf="data.connectionChangeRequestType === ConnectionChangeRequestTypeEnum.CHANGE">
    <h2>Durchführungen der Anschlussänderung</h2>
    <app-value-with-label
      *ngIf="config.powerIncreaseField !== FieldConfigEnum.HIDDEN"
      [label]="'Leistungserhöhung'"
      [value]="data.powerIncrease ? 'Ja' : 'Nein'" />
    <app-value-with-label
      *ngIf="config.moveConnectionLineField !== FieldConfigEnum.HIDDEN"
      [breakLineBefore]="true"
      [label]="'Verlegung der Anschlussleitung'"
      [value]="data.moveConnectionLine ? 'Ja' : 'Nein'" />
    <app-value-with-label
      *ngIf="config.moveServiceEntranceBoxField !== FieldConfigEnum.HIDDEN && data.area === AllAreaEnum.Power"
      [breakLineBefore]="true"
      [label]="'Verlegung des Hausanschlusskastens'"
      [value]="data.moveServiceEntranceBox ? 'Ja' : 'Nein'" />
  </section>
  <section>
    <h2>Technische Informationen</h2>
    <app-value-with-label
      [label]="'Art des Vorgangs'"
      [value]="ConnectionChangeRequestTypeDisplayValues[data.connectionChangeRequestType]?.name" />
    <app-value-with-label [breakLineBefore]="true" [label]="'Sparte'" [value]="AreaDisplayName[data.area]" />
    <ng-container *ngIf="data.connectionChangeRequestType === ConnectionChangeRequestTypeEnum.CHANGE">
      <ng-container *ngIf="data.powerIncrease">
        <app-value-with-label
          *ngIf="!!data.installedPower"
          [breakLineBefore]="true"
          [label]="'Angeschlossene Leistung'"
          [value]="data.installedPower + ' ' + config.defaultPowerUnit" />
        <app-value-with-label
          *ngIf="!!data.installedFuse"
          [breakLineBefore]="true"
          [label]="'Hausanschlusssicherung'"
          [value]="data.installedFuse" />
        <app-value-with-label
          [breakLineBefore]="true"
          [label]="'Benötigte Leistung'"
          [value]="data.requiredPower + ' ' + config.defaultPowerUnit" />
        <app-value-with-label
          *ngIf="config.explosiveField !== FieldConfigEnum.HIDDEN"
          [breakLineBefore]="true"
          [label]="'Notwendige Tiefbauarbeiten'"
          [value]="CivilEngineeringDisplayNames[data.civilEngineering] || ''" />
      </ng-container>
      <ng-container *ngIf="data.moveConnectionLine">
        <app-value-with-label
          [breakLineBefore]="true"
          [label]="'Grund der Verlegung der Anschlussleitung'"
          [value]="data.lineChangeComment" />
      </ng-container>
    </ng-container>
    <ng-container *ngIf="data.connectionChangeRequestType === ConnectionChangeRequestTypeEnum.DISCONNECTION">
      <app-value-with-label
        [breakLineBefore]="true"
        [label]="'Das Haus ist unbewohnt und freigeräumt'"
        [value]="data.isEmptyHouse ? 'Ja' : 'Nein'" />
      <br />
      <span>Für die Anschlusstrennung ausgewählte Sparten:</span>
      <ul style="margin-top: 0">
        <li *ngFor="let area of data.areas">{{ AreaDisplayName[area] }}</li>
      </ul>
    </ng-container>
    <ng-container *ngIf="data.connectionChangeRequestType === ConnectionChangeRequestTypeEnum.TEMPORARY">
      <app-value-with-label
        *ngIf="config.requiredPowerFieldInTemporary !== FieldConfigEnum.HIDDEN && !!data.requiredPower"
        [breakLineBefore]="true"
        [label]="'Benötigte Leistung'"
        [value]="data.requiredPower + ' ' + config.defaultPowerUnit" />
      <app-value-with-label
        [breakLineBefore]="true"
        [label]="'Zeitraum des temporären Anschlusses'"
        [value]="data.fromDate | date : 'shortDate' + ' - ' + data.toDate | date : 'shortDate'" />
    </ng-container>
    <ng-container *ngIf="data.connectionChangeRequestType !== ConnectionChangeRequestTypeEnum.TEMPORARY">
      <app-value-with-label
        *ngIf="config.deviceNumberField !== FieldConfigEnum.HIDDEN && !!data.meterNumber"
        [breakLineBefore]="true"
        [label]="'Zählernummer'"
        [value]="data.meterNumber" />
    </ng-container>
  </section>
  <section>
    <h2>Weitere Informationen</h2>
    <app-value-with-label
      [label]="'Sie sind Eigentümer des Anschlussobjektes'"
      [value]="data.isOwner ? 'Ja' : 'Nein'" />
    <app-value-with-label
      *ngIf="
        config.supplyAppointmentWishDateField !== FieldConfigEnum.HIDDEN &&
        data.connectionChangeRequestType !== ConnectionChangeRequestTypeEnum.TEMPORARY
      "
      [breakLineBefore]="true"
      [label]="'Kalenderwoche des Wunschdatums'"
      [value]="
        data.supplyAppointmentWishDate
          ? 'KW ' + getCalendarWeek(data.supplyAppointmentWishDate)
          : 'Keine Präferenz'
      " />
    <ng-container *ngIf="data.uploads?.length > 0; else noUploads">
      <br />
      <span>Hochgeladene Dokumente:</span>
      <ul style="margin-top: 0">
        <li *ngFor="let upload of data.uploads">{{ upload.displayName || upload.fileName }}</li>
      </ul>
    </ng-container>
    <ng-template #noUploads>
      <app-value-with-label
        [breakLineBefore]="true"
        [label]="'Dokumente'"
        [value]="'Sie haben keine Dokumente hochgeladen'" />
    </ng-template>
  </section>
</ng-container>
<ng-template #noData>
  <p>Keine Daten vorhanden</p>
</ng-template>
